import { useClients } from "../../lib/queries";

/** "1 site", "2 sites": the counts read as plain English. */
export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** The client from the cached client list (one request serves the column, the binder and the tabs). */
export function useClient(clientId: string) {
  const query = useClients();
  return { ...query, client: query.data?.find((c) => c.id === clientId) };
}
